module.exports = __webpack_public_path__ + "img/cs.91519323.svg";